exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".account-cancellation-container{padding:0 16px;letter-spacing:1px}.account-cancellation-container .account-cancellation-sub-title{color:#7cc26a;font-weight:700;font-size:15px;padding:12px 0}.account-cancellation-container .account-cancellation-des-list-container{background:#fff;border-radius:12px;padding:13px;font-size:14px;color:#706868}.account-cancellation-container .account-cancellation-btn{width:calc(100% - 32px);background-color:#7cc26a;color:#fff;font-size:16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;letter-spacing:2px;height:36px;border-radius:22px;position:fixed;bottom:90px;left:16px;right:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-450655d2","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/Profile/accountCancellation.vue
// module id = L73G
// module chunks = 1